// import React from 'react';
// import EditorWrapper from "../EditorWrapper/EditorWrapper";
// import Icon from "../Icon";
// import svgSortAsc from "../../svgs/arrow-up.svg";
// import {getData, manageData} from "../../requests/CRUD";
// import {TRAINING, TRAINING_CONTENT} from "../../consts/tables";

// export default class ContentPage extends React.Component {
//     constructor(props) {
//         super(props);

//         this.state = {
//             title: '',
//             image: '',
//             backButton: '',
//             subchapterParentSlug: '',
//             isEdit: false,
//         };

//         this.editorRef = React.createRef();
//         this.contentRef = React.createRef();

//         this.saveEditorContent = this.saveEditorContent.bind(this);
//         this.cancelEditorChanges = this.cancelEditorChanges.bind(this);
//         this.toggleEdit = this.toggleEdit.bind(this);
//     }

//     componentDidMount() {
//         const keys = Object.keys(this.props.params);
//         const slugs = this.props.params && keys.length ? keys.map(key => this.props.params[key]) : [];
//         const subchapterParentSlug = slugs.join('/');
//         const slug = slugs[slugs.length - 1] || '';
//         const parentChapterSlug = slugs[slugs.length - 2] || '';
//         slugs.pop();
//         const parentSlug = slugs.join('/') || 'training';
//         slugs.pop();
//         const parentChapterParentSlug = slugs.join('/') || 'training';

//         Promise.all([
//             getData({
//                 tableCode: TRAINING,
//                 options: {
//                     column: [
//                         'NAME',
//                         'PHOTO',
//                     ],
//                     filter: [{
//                         text: '',
//                         code: 'DELETED',
//                         type: 'null',
//                     }, {
//                         text: parentSlug,
//                         code: 'PARENT_SLUG',
//                         type: 'exact',
//                     }, {
//                         text: slug,
//                         code: 'SLUG',
//                         type: 'exact',
//                     }],
//                     filterType: 'and',
//                 },
//             }),
//             getData({
//                 tableCode: TRAINING,
//                 options: {
//                     column: [
//                         'NAME',
//                     ],
//                     filter: [{
//                         text: '',
//                         code: 'DELETED',
//                         type: 'null',
//                     }, {
//                         text: parentChapterParentSlug,
//                         code: 'PARENT_SLUG',
//                         type: 'exact',
//                     }, {
//                         text: parentChapterSlug,
//                         code: 'SLUG',
//                         type: 'exact',
//                     }],
//                     filterType: 'and',
//                 },
//             }),
//             getData({
//                 tableCode: TRAINING_CONTENT,
//                 options: {
//                     column: [
//                         'CONTENT',
//                         'PHOTO'
//                     ],
//                     filter: [{
//                         text: '',
//                         code: 'DELETED',
//                         type: 'null',
//                     }, {
//                         text: subchapterParentSlug,
//                         code: 'CHAPTER_SLUG',
//                         type: 'exact',
//                     }],
//                     filterType: 'and',
//                 },
//             }),
//         ]).then(res => {
//             if (res && res[0] && res[0].success && res[1] && res[1].success && res[2] && res[2].success) {
//                 if (this.contentRef.current)
//                     this.contentRef.current.innerHTML = res[2].data[0] ? res[2].data[0].CONTENT : '';
//                 const photo = res[2].data[0] && res[2].data[0].PHOTO ? res[2].data[0].PHOTO : res[0].data[0].PHOTO;
//                 this.setState({
//                     title: res[0].data[0].NAME ? res[0].data[0].NAME.replace('<br/>', ' ') : '',
//                     image: `${arc.path.media}${photo}` || '',
//                     backButton: res[1].data[0] && res[1].data[0].NAME || 'TRAINING',
//                     subchapterParentSlug,
//                 });
//             }
//         });
//     }

//     saveEditorContent() {
//         if (this.editorRef.current) {
//             const content = this.editorRef.current.getContent();
//             manageData({
//                 tableCode: TRAINING_CONTENT,
//                 data: [{
//                     CHAPTER_SLUG: this.state.subchapterParentSlug,
//                     CONTENT: content
//                 }]
//             }).then(res => {
//                 if (res && res.success && this.contentRef.current) {
//                     this.contentRef.current.innerHTML = content;
//                     this.toggleEdit();
//                     return;
//                 }
//                 alert(res.message || 'Unexpected error');
//             });
//         }
//     }

//     cancelEditorChanges() {
//         if (this.editorRef.current && this.contentRef.current)
//             this.editorRef.current.setContent(this.contentRef.current.innerHTML);
//         this.toggleEdit();
//     }

//     toggleEdit() {
//         this.setState(prevState => {
//             return {
//                 isEdit: !prevState.isEdit
//             }
//         });
//     }

//     render() {
//         const {isSuper} = this.props;
//         const {title, image, backButton, isEdit} = this.state;

//         return (
//             <div className='ContentPage'>
//                 <div className='page-rounded-corner-container'>
//                     <div className='page-header-container'>
//                         <div className='page-back-button'
//                              onClick={() => {history.back()}}>
//                             <Icon svg={svgSortAsc}/>
//                             {backButton}
//                         </div>
//                         <div className='page-header'>
//                             <div className='page-title'>{title}</div>
//                             {
//                                 isSuper && isEdit &&
//                                 <React.Fragment>
//                                     <div className='button-new negative' onClick={this.cancelEditorChanges}>Cancel</div>
//                                     <div className='button-new positive' onClick={this.saveEditorContent}>Save</div>
//                                 </React.Fragment>
//                             }
//                             {
//                                 isSuper && !isEdit &&
//                                 <div className='button-new positive' onClick={this.toggleEdit}>Edit</div>
//                             }
//                         </div>
//                         <div className='line'/>
//                     </div>
//                 </div>
//                 <div className='page-body-container'>
//                     <img src={image} className='content-image' alt=''/>
//                     <div ref={this.contentRef} className={isSuper && isEdit ? 'hidden' : ''}/>
//                     <EditorWrapper
//                         content={this.contentRef.current && this.contentRef.current.innerHTML || ''}
//                         ref={this.editorRef}
//                         className={!isSuper || !isEdit ? 'hidden' : ''}
//                     />
//                 </div>
//             </div>
//         )
//     }
// }
//#region Old Code

// import React from 'react';
// import EditorWrapper from "../EditorWrapper/EditorWrapper";
// import Icon from "../Icon";
// import svgSortAsc from "../../svgs/arrow-up.svg";
// import {getData, manageData} from "../../requests/CRUD";
// import {TRAINING, TRAINING_CONTENT} from "../../consts/tables";

// export default class ContentPage extends React.Component {
//     constructor(props) {
//         super(props);

//         this.state = {
//             title: '',
//             image: '',
//             backButton: '',
//             subchapterParentSlug: '',
//             isEdit: false,
//         };

//         this.editorRef = React.createRef();
//         this.contentRef = React.createRef();

//         this.saveEditorContent = this.saveEditorContent.bind(this);
//         this.cancelEditorChanges = this.cancelEditorChanges.bind(this);
//         this.toggleEdit = this.toggleEdit.bind(this);
//     }

//     componentDidMount() {
//         const keys = Object.keys(this.props.params);
//         const slugs = this.props.params && keys.length ? keys.map(key => this.props.params[key]) : [];
//         const subchapterParentSlug = slugs.join('/');
//         const slug = slugs[slugs.length - 1] || '';
//         const parentChapterSlug = slugs[slugs.length - 2] || '';
//         slugs.pop();
//         const parentSlug = slugs.join('/') || 'training';
//         slugs.pop();
//         const parentChapterParentSlug = slugs.join('/') || 'training';

//         Promise.all([
//             getData({
//                 tableCode: TRAINING,
//                 options: {
//                     column: [
//                         'NAME',
//                         'PHOTO',
//                     ],
//                     filter: [{
//                         text: '',
//                         code: 'DELETED',
//                         type: 'null',
//                     }, {
//                         text: parentSlug,
//                         code: 'PARENT_SLUG',
//                         type: 'exact',
//                     }, {
//                         text: slug,
//                         code: 'SLUG',
//                         type: 'exact',
//                     }],
//                     filterType: 'and',
//                 },
//             }),
//             getData({
//                 tableCode: TRAINING,
//                 options: {
//                     column: [
//                         'NAME',
//                     ],
//                     filter: [{
//                         text: '',
//                         code: 'DELETED',
//                         type: 'null',
//                     }, {
//                         text: parentChapterParentSlug,
//                         code: 'PARENT_SLUG',
//                         type: 'exact',
//                     }, {
//                         text: parentChapterSlug,
//                         code: 'SLUG',
//                         type: 'exact',
//                     }],
//                     filterType: 'and',
//                 },
//             }),
//             getData({
//                 tableCode: TRAINING_CONTENT,
//                 options: {
//                     column: [
//                         'CONTENT',
//                         'PHOTO'
//                     ],
//                     filter: [{
//                         text: '',
//                         code: 'DELETED',
//                         type: 'null',
//                     }, {
//                         text: subchapterParentSlug,
//                         code: 'CHAPTER_SLUG',
//                         type: 'exact',
//                     }],
//                     filterType: 'and',
//                 },
//             }),
//         ]).then(res => {
//             if (res && res[0] && res[0].success && res[1] && res[1].success && res[2] && res[2].success) {
//                 if (this.contentRef.current)
//                     this.contentRef.current.innerHTML = res[2].data[0] ? res[2].data[0].CONTENT : '';
//                 const photo = res[2].data[0] && res[2].data[0].PHOTO ? res[2].data[0].PHOTO : res[0].data[0].PHOTO;
//                 this.setState({
//                     title: res[0].data[0].NAME ? res[0].data[0].NAME.replace('<br/>', ' ') : '',
//                     image: `${arc.path.media}${photo}` || '',
//                     backButton: res[1].data[0] && res[1].data[0].NAME || 'TRAINING',
//                     subchapterParentSlug,
//                 });
//             }
//         });
//     }

//     saveEditorContent() {
//         if (this.editorRef.current) {
//             const content = this.editorRef.current.getContent();
//             manageData({
//                 tableCode: TRAINING_CONTENT,
//                 data: [{
//                     CHAPTER_SLUG: this.state.subchapterParentSlug,
//                     CONTENT: content
//                 }]
//             }).then(res => {
//                 if (res && res.success && this.contentRef.current) {
//                     this.contentRef.current.innerHTML = content;
//                     this.toggleEdit();
//                     return;
//                 }
//                 alert(res.message || 'Unexpected error');
//             });
//         }
//     }

//     cancelEditorChanges() {
//         if (this.editorRef.current && this.contentRef.current)
//             this.editorRef.current.setContent(this.contentRef.current.innerHTML);
//         this.toggleEdit();
//     }

//     toggleEdit() {
//         this.setState(prevState => {
//             return {
//                 isEdit: !prevState.isEdit
//             }
//         });
//     }

//     render() {
//         const {isSuper} = this.props;
//         const {title, image, backButton, isEdit} = this.state;

//         return (
//             <div className='ContentPage'>
//                 <div className='page-rounded-corner-container'>
//                     <div className='page-header-container'>
//                         <div className='page-back-button'
//                              onClick={() => {history.back()}}>
//                             <Icon svg={svgSortAsc}/>
//                             {backButton}
//                         </div>
//                         <div className='page-header'>
//                             <div className='page-title'>{title}</div>
//                             {
//                                 isSuper && isEdit &&
//                                 <React.Fragment>
//                                     <div className='button-new negative' onClick={this.cancelEditorChanges}>Cancel</div>
//                                     <div className='button-new positive' onClick={this.saveEditorContent}>Save</div>
//                                 </React.Fragment>
//                             }
//                             {
//                                 isSuper && !isEdit &&
//                                 <div className='button-new positive' onClick={this.toggleEdit}>Edit</div>
//                             }
//                         </div>
//                         <div className='line'/>
//                     </div>
//                 </div>
//                 <div className='page-body-container'>
//                     <img src={image} className='content-image' alt=''/>
//                     <div ref={this.contentRef} className={isSuper && isEdit ? 'hidden' : ''}/>
//                     <EditorWrapper
//                         content={this.contentRef.current && this.contentRef.current.innerHTML || ''}
//                         ref={this.editorRef}
//                         className={!isSuper || !isEdit ? 'hidden' : ''}
//                     />
//                 </div>
//             </div>
//         )
//     }
// }

//#endregion

import React from 'react';
import EditorWrapper from "../EditorWrapper/EditorWrapper";
import Icon from "../Icon";
import svgSortAsc from "../../svgs/arrow-up.svg";
import { getData, manageData } from "../../requests/CRUD";
import { TRAINING } from "../../consts/tables";
// import { TRAINING_CONTENT } from "../../consts/tables";
import { ApolloConsumer } from '@apollo/client';
import { GET_TRAINING, GET_TRAINING_CONTENT } from '../Graphql/Queries/TrainingQuery';
import { TRAINING_CONTENT, TRAINING as TRAINING_MUTATION } from '../Graphql/Mutations/TrainingMutation';
import { fetchData, mutateData } from '../Service/graphQlService';
import SubChapterCard from "../SubChapterCard";
import { getBase64 } from "../../utils";
import { existingFileError, existingFileErrorMessage } from "../../consts/consts";
import { removeFile, uploadFile } from "../../requests/fileRequests";

const FOLDER = 'training';

export default class ContentPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            title: '',
            image: '',
            backButton: '',
            subchapterParentSlug: '',
            isEdit: false,
            contentResp: {
                ARCIMEDES_ROW_ID: null
            },
            newTile: { visible: false },
            tileError: null,
            nodeName: '',
            nodeImagePath: null
        };

        this.editorRef = React.createRef();
        this.contentRef = React.createRef();

        this.saveEditorContent = this.saveEditorContent.bind(this);
        this.cancelEditorChanges = this.cancelEditorChanges.bind(this);
        this.toggleEdit = this.toggleEdit.bind(this);
        this.handleTileChange = this.handleTileChange.bind(this);
        this.validateTileFile = this.validateTileFile.bind(this);
        this.removeTilePhoto = this.removeTilePhoto.bind(this);
        this.saveNewTile = this.saveNewTile.bind(this);
        this.cancelNewTile = this.cancelNewTile.bind(this);
    }

    componentDidMount() {
        const keys = Object.keys(this.props.params);
        const slugs = this.props.params && keys.length ? keys.map(key => this.props.params[key]) : [];
        const subchapterParentSlug = slugs.join('/');
        const slug = slugs[slugs.length - 1] || '';
        const parentChapterSlug = slugs[slugs.length - 2] || '';
        slugs.pop();
        const parentSlug = slugs.join('/') || 'training';
        slugs.pop();
        const parentChapterParentSlug = slugs.join('/') || 'training';
        const token = localStorage.getItem('authToken');
        Promise.all([

            // this.client.query({
            //     query: GET_TRAINING, variables: {
            //         filter: [{ text: '', code: 'DELETED', type: 'null' },
            //         { text: parentSlug, code: 'PARENT_SLUG', type: 'exact' },
            //         { text: slug, code: 'SLUG', type: 'exact' }],
            //         filterType: 'and'
            //     }
            // }),
            // this.client.query({
            //     query: GET_TRAINING, variables: {
            //         filter: [{ text: '', code: 'DELETED', type: 'null' },
            //         { text: parentChapterParentSlug, code: 'PARENT_SLUG', type: 'exact' },
            //         { text: parentChapterSlug, code: 'SLUG', type: 'exact' }],
            //         filterType: 'and'
            //     }
            // }),
            // this.client.query({
            //     query: GET_TRAINING_CONTENT, variables: {
            //         filter: [{ text: '', code: 'DELETED', type: 'null' },
            //         { text: subchapterParentSlug, code: 'CHAPTER_SLUG', type: 'exact' }],
            //         filterType: 'and'
            //     }
            // })
            // this.client.query({
            //     query: GET_TRAINING, variables: { filters: { 'PARENT_SLUG': parentSlug, SLUG: slug } }, fetchPolicy: "no-cache",
            //     context: {
            //         headers: {
            //             authorization: `Bearer ${token}`, // Bearer token added here
            //         },
            //     }
            // }),
            fetchData(GET_TRAINING, { filters: { 'PARENT_SLUG': parentSlug, SLUG: slug } }),
            // this.client.query({
            //     query: GET_TRAINING, variables: { filters: { 'PARENT_SLUG': parentChapterParentSlug, SLUG: parentChapterSlug } }, fetchPolicy: "no-cache",
            //     context: {
            //         headers: {
            //             authorization: `Bearer ${token}`, // Bearer token added here
            //         },
            //     }
            // }),
            fetchData(GET_TRAINING, { filters: { 'PARENT_SLUG': parentChapterParentSlug, SLUG: parentChapterSlug } }),
            // this.client.query({
            //     query: GET_TRAINING_CONTENT, variables: { filters: { "CHAPTER_SLUG": subchapterParentSlug } }, fetchPolicy: "no-cache",
            //     context: {
            //         headers: {
            //             authorization: `Bearer ${token}`, // Bearer token added here
            //         },
            //     }
            // })
            fetchData(GET_TRAINING_CONTENT, { filters: { "CHAPTER_SLUG": subchapterParentSlug } })
        ]).then(res => {
            if (res && res[0] && res[0].data.getTrainingFilter.data && res[1] && res[1].data.getTrainingFilter.data && res[2] && res[2].data.getTrainingContentFilter.data) {
                if (this.contentRef.current)
                    this.contentRef.current.innerHTML = res[2].data.getTrainingContentFilter.data[0] ? res[2].data.getTrainingContentFilter.data[0].CONTENT : '';
                const photo = res[2].data.getTrainingContentFilter.data[0] && res[2].data.getTrainingContentFilter.data[0].PHOTO ? res[2].data.getTrainingContentFilter.data[0].PHOTO : res[0].data.getTrainingFilter.data[0].PHOTO;
                this.setState({
                    title: res[0].data.getTrainingFilter.data[0].NAME ? res[0].data.getTrainingFilter.data[0].NAME.replace('<br/>', ' ') : '',
                    image: photo || '',
                    backButton: res[1].data.getTrainingFilter.data[0] && res[1].data.getTrainingFilter.data[0].NAME || 'TRAINING',
                    subchapterParentSlug,
                    contentResp: res[2].data.getTrainingContentFilter.data[0],
                    nodeName: res[0].data.getTrainingFilter.data[0].NAME || '',
                    nodeImagePath: res[0].data.getTrainingFilter.data[0].IMAGEPATH || null
                });
            }
        });
    }

    saveEditorContent() {
        const token = localStorage.getItem('authToken');
        if (this.editorRef.current) {
            const content = this.editorRef.current.getContent();
            
        //     this.client.mutate({
        //     //({ mutation: TRAINING_CONTENT, variables: { input: {CHAPTER_SLUG: this.state.subchapterParentSlug,CONTENT: content} } })
        //     mutation: TRAINING_CONTENT,
        //     variables: { input: [{chapter_slug: this.state.subchapterParentSlug,content: content}]  },
        //     fetchPolicy: "no-cache",
        //     context: {
        //       headers: {
        //         authorization: `Bearer ${token}`,
        //       },
        //     },
        //   })
        let input = {chapter_slug: this.state.subchapterParentSlug,content: content}
        if(this.state.contentResp && this.state.contentResp.ARCIMEDES_ROW_ID){
            input = {arcimedes_row_id: this.state.contentResp.ARCIMEDES_ROW_ID, ...input}
        }
        mutateData(TRAINING_CONTENT, { input: [input]  })
            .then(res => {
                if (res && res.data.createOrUpdateTrainingContent && this.contentRef.current) {
                    this.contentRef.current.innerHTML = content;
                    this.toggleEdit();
                    return;
                }
                alert(res.data.createOrUpdateTrainingContent.message || 'Unexpected error');
            });
        }
    }

    cancelEditorChanges() {
        if (this.editorRef.current && this.contentRef.current)
            this.editorRef.current.setContent(this.contentRef.current.innerHTML);
        this.toggleEdit();
    }

    toggleEdit() {
        this.setState(prevState => {
            return {
                isEdit: !prevState.isEdit
            }
        });
    }

    getFullPathSlug() {
        const params = this.props.params || {};
        const keys = Object.keys(params);
        const slugs = keys.length ? keys.map(key => params[key]) : [];
        return slugs.join('/');
    }

    getNewSlug(title) {
        return title && title.toString().toLowerCase()
            .replace(/[&]/g, 'and')              //replace '&' with 'and'
            .replace(/<br\/>|\s(-|\/)\s/g, '')  // remove ' - ', ' / ', '</br>'
            .replace(/[^\w\s\/\-]/g, '')        //replace punctuation characters except '/' and '-'
            .replace(/[\/ ]/g, "-");            //replace ' ' and '/' with '-'
    }

    handleTileChange(key, value) {
        const newTile = { ...this.state.newTile, [key]: value };
        this.setState({ newTile });
    }

    validateTileFile(event) {
        const selectedFile = event.currentTarget.files[0];
        if (!selectedFile) return;
        if (selectedFile.size / 1000000 > 20) {
            this.setState({ tileError: 'Maximum file size exceeded' });
            return;
        }
        getBase64(selectedFile).then(result => {
            uploadFile({ fileName: selectedFile.name, base64File: result, folder: FOLDER }).then(res => {
                res = res.data.uploadImage;
                if (!res || !res.success) {
                    this.setState({
                        tileError: res && res.errorCode === existingFileError
                            ? existingFileErrorMessage
                            : (res && res.message ? res.message : 'Unspecified error')
                    });
                } else {
                    const newTile = { ...this.state.newTile };
                    newTile.img = res.fileUrl.fileUrl;
                    newTile.imageAddress = res.fileUrl.s3_url;
                    this.setState({ newTile, tileError: null });
                }
            }).catch(() => {
                this.setState({ tileError: 'Error uploading photo' });
            });
        });
    }

    removeTilePhoto() {
        const fileName = this.state.newTile.imageAddress;
        const clearPhoto = () => {
            const newTile = { ...this.state.newTile, img: null, imageAddress: null };
            this.setState({ newTile });
        };
        if (!fileName) {
            clearPhoto();
            return;
        }
        removeFile(fileName).then(clearPhoto).catch(clearPhoto);
    }

    saveNewTile() {
        const { newTile, contentResp, nodeName, nodeImagePath } = this.state;
        if (!newTile.title) {
            this.setState({ tileError: 'Title is required' });
            return;
        }
        const path = this.getFullPathSlug();

        // If this page already has content (text/image), move it into its own "content tile"
        // so the page becomes a tile view and nothing is lost.
        const hasContent = contentResp && contentResp.ARCIMEDES_ROW_ID && (contentResp.CONTENT || contentResp.PHOTO);
        const contentTileSlug = hasContent ? this.getNewSlug(nodeName || newTile.title) : null;
        if (hasContent && this.getNewSlug(newTile.title) === contentTileSlug) {
            this.setState({ tileError: 'Please choose a different title: it clashes with this section\'s name' });
            return;
        }

        const input = [];
        let newTileIndex = parseInt(newTile.index) || 1;
        if (hasContent) {
            input.push({
                parent_slug: path,
                slug: contentTileSlug,
                name: nodeName,
                photo: contentResp.PHOTO || nodeImagePath || null,
                index: 1,
            });
            // The content tile takes the first spot.
            if (newTileIndex <= 1)
                newTileIndex = 2;
        }
        input.push({
            parent_slug: path,
            slug: this.getNewSlug(newTile.title),
            index: newTileIndex,
            photo: newTile.imageAddress || null,
            name: newTile.title,
        });

        const finish = () => {
            this.setState({ newTile: { visible: false }, tileError: null });
            // The page now has children: let the parent switch re-render it as a chapter page.
            if (this.props.onStructureChange)
                this.props.onStructureChange();
        };

        mutateData(TRAINING_MUTATION, { input }).then(res => {
            if (res && res.data && res.data.createOrUpdateTraining && res.data.createOrUpdateTraining.success) {
                if (hasContent) {
                    // Re-key the content row to the new content tile.
                    mutateData(TRAINING_CONTENT, {
                        input: [{
                            arcimedes_row_id: contentResp.ARCIMEDES_ROW_ID,
                            chapter_slug: `${path}/${contentTileSlug}`
                        }]
                    }).then(finish).catch(error => {
                        console.error("Error moving training content:", error);
                        finish();
                    });
                    return;
                }
                finish();
                return;
            }
            this.setState({
                tileError: res && res.data && res.data.createOrUpdateTraining && res.data.createOrUpdateTraining.message
                    ? res.data.createOrUpdateTraining.message
                    : 'Unspecified error'
            });
        }).catch(error => {
            console.error("Error saving training tile:", error);
            this.setState({ tileError: 'Error saving tile' });
        });
    }

    cancelNewTile() {
        if (this.state.newTile.imageAddress)
            this.removeTilePhoto();
        this.setState({ newTile: { visible: false }, tileError: null });
    }

    render() {
        const { isSuper } = this.props;
        const { title, image, backButton, isEdit, newTile, tileError } = this.state;
        // Admins can add sub-tiles below any training section.
        const canAddTiles = isSuper;

        return (
            <ApolloConsumer>
                {client => {
                    if (!this.client) {
                        this.client = client;
                    }
                    return (
                        <div className='ContentPage'>
                            <div className='page-rounded-corner-container'>
                                <div className='page-header-container'>
                                    <div className='page-back-button'
                                        onClick={() => { history.back() }}>
                                        <Icon svg={svgSortAsc} />
                                        {backButton}
                                    </div>
                                    <div className='page-header'>
                                        <div className='page-title'>{title}</div>
                                        {
                                            isSuper && isEdit &&
                                            <React.Fragment>
                                                <div className='button-new negative' onClick={this.cancelEditorChanges}>Cancel</div>
                                                <div className='button-new positive' onClick={this.saveEditorContent}>Save</div>
                                            </React.Fragment>
                                        }
                                        {
                                            isSuper && !isEdit &&
                                            <div className='button-new positive' onClick={this.toggleEdit}>Edit</div>
                                        }
                                    </div>
                                    <div className='line' />
                                </div>
                            </div>
                            <div className='page-body-container'>
                                <img src={image} className='content-image' alt='' />
                                <div ref={this.contentRef} className={isSuper && isEdit ? 'hidden' : ''} />
                                <EditorWrapper
                                    content={this.contentRef.current && this.contentRef.current.innerHTML || ''}
                                    ref={this.editorRef}
                                    className={!isSuper || !isEdit ? 'hidden' : ''}
                                />
                                {
                                    canAddTiles &&
                                    <div className='sub-tiles-container'>
                                        <div className='cards-container'>
                                            <SubChapterCard
                                                isNewChapter={true}
                                                isEdit={true}
                                                newChapter={newTile}
                                                handleParentChange={this.handleTileChange}
                                                error={tileError}
                                                validateSelectedFile={this.validateTileFile}
                                                removePhoto={() => this.removeTilePhoto()}
                                                addNewChapter={() => this.setState({ newTile: { visible: true } })}
                                            />
                                        </div>
                                        {
                                            newTile.visible &&
                                            <div className='tile-actions'>
                                                <div className='button-new negative' onClick={this.cancelNewTile}>Cancel</div>
                                                <div className='button-new positive' onClick={this.saveNewTile}>Save Tile</div>
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                    )
                }}
            </ApolloConsumer>
        )
    }
}